import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'currency-manat', 'CurrencyManat', [["path",{"d":"M7 19v-7a5 5 0 1 1 10 0v7"}],["path",{"d":"M12 5v14"}]]);